// extracted by mini-css-extract-plugin
module.exports = {"varWhite":"var(--tkww-union-color-white, var(--tkww-union-color-neutral-white, #FFF))","right-rail":"right-rail--18d5d","rightRail":"right-rail--18d5d"};